import { ApiState, Action } from '../../../../types';
import { serviceReducer } from '../../../../shared/hooks/serviceReducer';
import { EsrrSprTimelineContainer } from '../../../../services/types/EsrrSprTimeline';

const timelineReducer = (
  state: ApiState<EsrrSprTimelineContainer, number>,
  action: Action<EsrrSprTimelineContainer, number>
): ApiState<EsrrSprTimelineContainer, number> => serviceReducer(state, action);

export default timelineReducer;
